import { render } from "./AdFormatCard.vue?vue&type=template&id=3003e215&scoped=true"
import script from "./AdFormatCard.vue?vue&type=script&lang=js"
export * from "./AdFormatCard.vue?vue&type=script&lang=js"

import "./AdFormatCard.vue?vue&type=style&index=0&id=3003e215&scoped=true&lang=css"

import exportComponent from "/Users/datis/Developer/ad-impact/web-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3003e215"]])

export default __exports__